import { render, staticRenderFns } from "./OptionColor.vue?vue&type=template&id=2fd48eb8&scoped=true"
import script from "./OptionColor.vue?vue&type=script&lang=js"
export * from "./OptionColor.vue?vue&type=script&lang=js"
import style0 from "./OptionColor.vue?vue&type=style&index=0&id=2fd48eb8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd48eb8",
  null
  
)

export default component.exports